export default __webpack_public_path__ + "static/media/cross-line-1.04ab37e2.png";